/**
 * phase-fix-unfillable-form-detection — frontend labels for the
 * GovernmentForms fill-capability verdict (mirrors
 * src/lib/forms/formCapability.ts). null = verdict not yet computed
 * (pre-verdict upload; self-heals at the next generate attempt).
 */
export type FillCapability =
  | 'fillable'
  | 'xfa-dynamic'
  | 'xfa-hybrid'
  | 'encrypted'
  | 'no-fields';

export const CAPABILITY_BADGES: Readonly<
  Record<FillCapability, { label: string; tone: 'ok' | 'warn' }>
> = Object.freeze({
  fillable: { label: 'Fillable', tone: 'ok' },
  'xfa-dynamic': { label: 'Adobe XFA — manual fill', tone: 'warn' },
  'xfa-hybrid': { label: 'Adobe XFA hybrid — manual fill', tone: 'warn' },
  encrypted: { label: 'Encrypted — manual fill', tone: 'warn' },
  'no-fields': { label: 'No fillable fields', tone: 'warn' },
});

export const MANUAL_FILL_HINT =
  'Automated fill is unavailable for this form. Download it, fill it in Adobe Reader, and upload the completed PDF as a document.';

export function isAutoFillable(capability: string | null | undefined): boolean {
  // null = unknown (pre-verdict) — allow the attempt; the server computes the
  // verdict lazily and refuses with the explanation when non-fillable.
  return capability == null || capability === 'fillable';
}
